export const colors = {
  documentFieldNoteMarkerBg: 'var(--documentFieldNoteMarkerBg)',
  documentFieldNoteMarkerColor: 'var(--documentFieldNoteMarkerColor)',
};
